import { call, put, takeEvery } from 'redux-saga/effects';

import { channelsRequest } from '../../api/channels';
import { CHANNELS_REQUEST } from '../../constants/channels';
import { channelsActions } from '../../store/channels/actions';
import { Channel } from '../../components/TipPublish/interfaces/tip/Tip';

function* channelsRequestSaga(data: any): any {
  try {
    const channels = yield call(channelsRequest, data.payload);

    yield put(channelsActions.channelsSuccessAction(channels.space_channels));
  } catch (e: any) {
    yield put(channelsActions.channelsFailureAction(e));
  }
}
function* channelsSaga() {
  yield takeEvery(CHANNELS_REQUEST, channelsRequestSaga);
}

export default channelsSaga;
